// extracted by mini-css-extract-plugin
export default {"navbar-section":"navbar_navbar-section__jNNlu","navbar":"navbar_navbar__PS5wV","logo":"navbar_logo__sbSH0","navList":"navbar_navList__8Ph1r"};